(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hugsy-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.gp');
    if (!root) return;
    const money = cents => new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100);
    let variants = [];
    try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) { variants = []; }
    const charBtns = [...root.querySelectorAll('[data-character]')];
    const bundleBtns = [...root.querySelectorAll('[data-bundle]')];
    const galleryImages = [...root.querySelectorAll('.gp-gallery__image')];
    const thumbs = [...root.querySelectorAll('[data-gallery-index]')];
    const sticky = root.querySelector('[data-sticky]');
    const buyCta = root.querySelector('#buy-cta');
    const stickyPicks = [...root.querySelectorAll('[data-sticky-pick]')];
    const heroBadges = root.querySelector('[data-hero-badges]');
    let galleryIndex = 0;

    const selectedChar = () => root.querySelector('[data-character].is-active') || charBtns[0];
    const selectedBundle = () => root.querySelector('[data-bundle].is-active') || bundleBtns[0];
    const currentVariant = () => {
      const character = selectedChar()?.dataset.character;
      const bundle = selectedBundle()?.dataset.bundle;
      return variants.find(v => v.character === character && v.bundle === bundle);
    };

    const setGallery = (index) => {
      galleryIndex = (index + galleryImages.length) % galleryImages.length;
      galleryImages.forEach((img, i) => img.classList.toggle('is-active', i === galleryIndex));
      thumbs.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === galleryIndex);
        btn.setAttribute('aria-selected', i === galleryIndex ? 'true' : 'false');
      });
      if (heroBadges) heroBadges.hidden = galleryIndex !== 0;
    };

    const refresh = () => {
      const char = selectedChar();
      const bundle = selectedBundle();
      if (!char || !bundle) return;
      const price = Number(bundle.dataset.price);
      const compare = Number(bundle.dataset.compare);
      const save = compare > price ? Math.round((1 - price / compare) * 100) : 0;
      const label = `${char.dataset.character} the ${char.dataset.animal}`;
      root.querySelector('[data-char-label]').textContent = label;
      const priceEl = root.querySelector('[data-price]');
      const compareEl = root.querySelector('[data-compare]');
      const saveEl = root.querySelector('[data-save]');
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) compareEl.textContent = money(compare);
      if (saveEl) {
        saveEl.hidden = !save;
        if (save) saveEl.textContent = `Save ${save}%`;
      }
      const atc = root.querySelector('[data-atc-label]');
      if (atc) atc.textContent = `Add to cart · ${money(price)}`;
      const final = root.querySelector('[data-final-label]');
      if (final) final.textContent = `Add ${char.dataset.character} to cart · ${money(price)}`;
      const stickyLabel = root.querySelector('[data-sticky-label]');
      if (stickyLabel) stickyLabel.textContent = `Add ${char.dataset.character} to cart`;
      root.querySelectorAll('[data-sticky-price], [data-sticky-price-lg]').forEach(el => { el.textContent = money(price); });
      const name = root.querySelector('[data-sticky-name]');
      const animal = root.querySelector('[data-sticky-animal]');
      const desk = root.querySelector('[data-sticky-desk-name]');
      if (name) name.textContent = char.dataset.character;
      if (animal) animal.textContent = char.dataset.animal;
      if (desk) desk.textContent = label;
      root.querySelectorAll('[data-sticky-bundle], [data-sticky-bundle-sm]').forEach(el => { el.textContent = bundle.dataset.bundle; });
      stickyPicks.forEach(btn => {
        const on = btn.dataset.stickyPick === char.dataset.character;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const hero = root.querySelector('[data-gallery-slot="hero"]');
      if (hero) {
        hero.src = char.dataset.image;
        hero.alt = `${label} shown half in daylight, half glowing in the dark`;
      }
      const heroThumb = root.querySelector('[data-hero-thumb] img');
      if (heroThumb) heroThumb.src = char.dataset.image;
    };

    charBtns.forEach(btn => btn.addEventListener('click', () => {
      charBtns.forEach(el => {
        el.classList.toggle('is-active', el === btn);
        el.setAttribute('aria-pressed', el === btn ? 'true' : 'false');
      });
      setGallery(0);
      refresh();
    }));
    bundleBtns.forEach(btn => btn.addEventListener('click', () => {
      bundleBtns.forEach(el => {
        el.classList.toggle('is-active', el === btn);
        el.setAttribute('aria-checked', el === btn ? 'true' : 'false');
      });
      refresh();
    }));
    thumbs.forEach(btn => btn.addEventListener('click', () => setGallery(Number(btn.dataset.galleryIndex))));
    stickyPicks.forEach(btn => btn.addEventListener('click', () => {
      charBtns.find(el => el.dataset.character === btn.dataset.stickyPick)?.click();
    }));
    root.querySelectorAll('[data-pick-character]').forEach(btn => btn.addEventListener('click', () => {
      charBtns.find(el => el.dataset.character === btn.dataset.pickCharacter)?.click();
      root.querySelector('#buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    const addToCart = async (button) => {
      const variant = currentVariant();
      if (!variant) return;
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variant.id), quantity: 1, properties: { 'Shipping included': 'Free worldwide' } }]
          })
        });
        if (!response.ok) throw new Error('Could not add to cart');
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (e) {
        button.innerHTML = original;
        button.disabled = false;
        button.textContent = 'Try again';
      }
    };
    root.querySelector('[data-add-to-cart]')?.addEventListener('click', e => addToCart(e.currentTarget));
    root.querySelector('[data-sticky-add]')?.addEventListener('click', e => addToCart(e.currentTarget));
    root.querySelector('[data-final-add]')?.addEventListener('click', e => addToCart(e.currentTarget));

    if (sticky && buyCta) {
      new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: 0 }).observe(buyCta);
    }

    const canvas = root.querySelector('[data-glow-canvas]');
    const hint = root.querySelector('[data-glow-hint]');
    if (canvas) {
      const ctx = canvas.getContext('2d');
      const strokes = [];
      let pen = null;
      let touched = false;
      const FADE = 5000;
      const resize = () => {
        const dpr = window.devicePixelRatio || 1;
        const { width, height } = canvas.getBoundingClientRect();
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      };
      resize();
      window.addEventListener('resize', resize);
      const point = (e) => {
        const r = canvas.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top, t: performance.now() };
      };
      const render = () => {
        const now = performance.now();
        const { width, height } = canvas.getBoundingClientRect();
        ctx.clearRect(0, 0, width, height);
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        for (let s = strokes.length - 1; s >= 0; s--) {
          strokes[s] = strokes[s].filter(p => now - p.t < FADE);
          if (!strokes[s].length) strokes.splice(s, 1);
        }
        for (const s of strokes) {
          for (let i = 1; i < s.length; i++) {
            const a = s[i - 1];
            const b = s[i];
            const life = 1 - (now - b.t) / FADE;
            ctx.strokeStyle = `rgba(141, 255, 185, ${Math.max(life, 0)})`;
            ctx.shadowColor = `rgba(141, 255, 185, ${Math.max(life * 0.9, 0)})`;
            ctx.shadowBlur = 16;
            ctx.lineWidth = 5;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
          }
        }
        if (pen) {
          ctx.shadowColor = 'rgba(150, 100, 255, 1)';
          ctx.shadowBlur = 24;
          ctx.fillStyle = '#c8b4ff';
          ctx.beginPath();
          ctx.arc(pen.x, pen.y, 5, 0, Math.PI * 2);
          ctx.fill();
        }
        requestAnimationFrame(render);
      };
      requestAnimationFrame(render);
      const startStroke = (e) => {
        const p = point(e);
        pen = p;
        strokes.push([p]);
        if (!touched) {
          touched = true;
          if (hint) hint.hidden = true;
        }
      };
      canvas.addEventListener('pointerdown', (e) => {
        canvas.setPointerCapture(e.pointerId);
        startStroke(e);
      });
      canvas.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') startStroke(e);
      });
      canvas.addEventListener('pointermove', (e) => {
        const p = point(e);
        pen = p;
        if (!strokes.length) strokes.push([]);
        strokes[strokes.length - 1].push(p);
        if (!touched) {
          touched = true;
          if (hint) hint.hidden = true;
        }
      });
      canvas.addEventListener('pointerleave', () => { pen = null; });
    }

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
